<span class="path{{ i }}" *ngFor="let i of count"></span>
